"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileRef = exports.ToManyList = exports.SearchResults = exports.VasatSearchQuery = exports.VasatAccessModel = exports.VasatModel = exports.VasatAPICall = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const types_1 = require("./types");
const chunked_upload_1 = require("./chunked_upload");
class VasatAPICall {
    apiObservable(vasat, meth, url, obj, args) {
        this._loading = true;
        let o = vasat._http(meth, url, obj).pipe((0, operators_1.mergeMap)(r => {
            var resp = r;
            return this.processResp(vasat, meth, url, resp, obj, args);
        }), (0, operators_1.catchError)((err) => {
            //console.log("Vasat api error: ",err)
            let ve;
            if (err instanceof types_1.VasatError) {
                ve = err;
            }
            else if (err['status'] && err['message'] && err['version']) {
                ve = new types_1.VasatError(err, null);
            }
            else if (err instanceof TypeError) {
                ve = new types_1.VasatError({ status: 99001, message: "" + err, version: "", time: new Date().getTime() }, err);
            }
            else {
                ve = new types_1.VasatError({ status: 99002, message: "Unknown Error: " + err, version: "", time: new Date().getTime() }, err);
            }
            if (args && args['pass_error'])
                return (0, rxjs_1.of)(ve);
            else
                return (0, rxjs_1.throwError)(ve);
        }));
        return o;
    }
    processResp(vasat, meth, url, resp, obj, args) {
        this._loading = false;
        if (!resp.status || resp.status >= 400) {
            this._error = resp;
            if (resp.status == 405) {
                if (vasat.localSession()) {
                    vasat.invalidateSession();
                }
            }
            //console.log("Enter API error: " + JSON.stringify(resp))
            if (args && args['pass_error'])
                return (0, rxjs_1.of)(new types_1.VasatError(resp, null));
            else
                throw new types_1.VasatError(resp, null);
        }
        else {
            this._error = null;
            return this.postProcess(meth, url, resp, obj, args);
        }
    }
    postProcess(meth, url, resp, obj, args) {
        return (0, rxjs_1.of)(resp.payload);
    }
}
exports.VasatAPICall = VasatAPICall;
class VasatModel extends VasatAPICall {
    constructor(vasat, _objType, vars) {
        super();
        this.vasat = vasat;
        this._objType = _objType;
        this.props = {}; // Default empty prompts rather than null
        this.setVals(vars);
    }
    get files() {
        var dn = this._domainName;
        var mp = this._modelPath;
        var path = this.urlPath();
        class FR extends FileRef {
            constructor(v) {
                super(v, '.files');
                this._modelPath = path;
            }
            urlRoot() {
                return (this._modelPath || this.vasat.modelPathPrefix(this)) + '.files';
            }
        }
        var res = this.vasat.searchByObject(FR);
        return res;
    }
    setVals(vars) {
        if (vars) {
            var t = typeof vars;
            if (t == 'object') {
                this.set(vars);
            }
            else {
                this.id = vars;
            }
        }
    }
    onReady() {
        //console.log('onReady ' + this.loading)
        if (!this.loading)
            return (0, rxjs_1.of)(this);
        else
            return this.loading;
    }
    /**
     * Sets the returned ID to this object.
     * Special case for MeUser is to set the response object as the api will returned the entire User object
     * @param args
     * @returns
     */
    set(args) {
        // If payload response is a string we assume is the object ID
        if (typeof args == "string") {
            this.id = args;
        }
        else {
            var isInline = Object.keys(args).filter(k => k != 'dateMade' && k != 'dateUpdated' && k != 'displayName' && k != 'item' && k != 'id' && k != 'paths' && k != 'acl' &&
                k != 'lastLogin' && k != 'remoteOAuthAgent' && k != 'lastPasswordChange');
            // Otherwise we add all the response object fields into this object
            Object.keys(args).forEach((k) => {
                if (k == 'item' && !isInline.length)
                    this.set(args[k]);
                else 
                // dont override toManyLists
                if (!(this[k] instanceof ToManyList))
                    this[k] = args[k];
            });
        }
        return this;
    }
    urlRoot() {
        return (this._modelPath || this.vasat.modelPathPrefix(this)) + '/' + this._objType;
    }
    urlPath() {
        if (this.id && this.id.trim().length) {
            return this.urlRoot() + "/" + this.id;
        }
        else
            return this.urlRoot();
    }
    fetch() {
        if (!this.id) {
            return (0, rxjs_1.of)(this);
        }
        else {
            this.loading = this.apiObservable(this.vasat, 'get', this.urlPath(), null, { pass_error: false }).pipe((0, operators_1.map)(o => {
                return o;
            }), (0, operators_1.share)());
            return this.loading;
        }
    }
    /**
     *
     * @deprecated Renamed to fetch()
     */
    fetchObservable() {
        return this.fetch();
    }
    save(deltaArgs) {
        if (this.loading) {
            this.loading.subscribe(_ => this.save(deltaArgs));
        }
        if (deltaArgs && !this.id) {
            throw Error('Cant save delta to theis obejct without a valid id');
        }
        else if (deltaArgs && !this.id) {
            this.loading = this.apiObservable(this.vasat, 'put', this.urlPath() + ".delta", deltaArgs, { pass_error: false }).pipe((0, operators_1.map)(o => {
                Object.keys(deltaArgs).forEach(element => {
                    this[element] = deltaArgs[element];
                });
                this.loading = null;
                return o;
            }), (0, operators_1.share)());
        }
        else {
            let json = this.toJSON();
            this.loading = this.apiObservable(this.vasat, /*(this.id?'put':'post')*/ 'post', this.urlPath(), json, { pass_error: false }).pipe((0, operators_1.map)(o => {
                //console.log("ENTER save obejct: ",o)
                this.loading = null;
                return o;
            }), (0, operators_1.share)());
        }
        return this.loading;
    }
    /**
     *
     * @deprecated Renamed to save()
     */
    saveObservable() {
        return this.save();
    }
    /**
     *
     * @deprecated Renamed to delete()
     */
    destroyObservable(params) {
        return this.delete(params);
    }
    delete(params) {
        if (!this.id) {
            return (0, rxjs_1.of)(this);
        }
        else if (!this.loading) {
            this.loading = this.apiObservable(this.vasat, 'delete', this.urlPath() + ((params) ? '?' + params : ''), null, { pass_error: false }).pipe((0, operators_1.share)());
        }
        return this.loading;
    }
    processResp(vasat, meth, url, resp, obj, args) {
        return super.processResp(vasat, meth, url, resp, obj, args).pipe((0, operators_1.mergeMap)(s => {
            this.loading = null;
            if (s instanceof types_1.VasatError) {
                args.pass_error = false;
                //console.log('throwing!' + s)
                throw s;
            }
            if (meth == 'delete') {
                this._deleted = true;
                return (0, rxjs_1.of)(null);
            }
            else if (resp.payload && meth != 'put') {
                this.set(resp.payload);
                return this.postSet(resp.payload);
            }
            else {
                return (0, rxjs_1.of)(this);
            }
        }));
    }
    postSet(objs, scope) {
        return (0, rxjs_1.of)(this);
    }
    toJSON(shallow) {
        var refed = [];
        var res = this._toJSON(this, 0, refed);
        delete res.dateMade;
        //delete res.acl
        delete res.dateUpdated;
        delete res.displayName;
        //delete res.id
        return res;
    }
    _toJSON(the_obj, depth, refMap) {
        if (the_obj == null) {
            return null;
        }
        else if (Array.isArray(the_obj)) {
            let a = the_obj;
            return the_obj.map((a) => this._toJSON(a, depth + 1, refMap));
        }
        else if (the_obj instanceof Date) {
            return the_obj.getTime();
        }
        else if (typeof the_obj == 'object') {
            // if this object has already been serialized, you cant serialize it again
            if (refMap.find((r) => r == the_obj) && depth) {
                if (the_obj instanceof VasatModel) {
                    return the_obj.id;
                }
                else {
                    console.warn("Warning recursive object in JSON ");
                    console.log(the_obj);
                    return null;
                }
            }
            refMap.push(the_obj);
            var json = {};
            Object.keys(the_obj).filter((k) => k != 'loading' && k != '_listenTos' && k != 'V' && k != '_eventBus' &&
                k != '_error' && k != '_loading' && k != '_deleted' && k != '_objType' &&
                k != 'vasat' && k != 'displayName' && k != 'dateMade' && k != 'dateUpdated' &&
                k != '_modelPath' && k != '_domainName' &&
                (k != 'id' || depth)).forEach((k) => {
                if (!(the_obj[k] instanceof ToManyList)) {
                    json[k] = this._toJSON(the_obj[k], depth + 1, refMap);
                }
            });
            if (the_obj instanceof VasatModel && depth) {
                json = the_obj.id;
            }
            return json;
        }
        else {
            return the_obj;
        }
    }
    /**
     * @deprecated renamed to fileUrl
     */
    file(fileName, cache = true, withMediaToken = true) {
        return this.fileUrl(fileName, cache, withMediaToken);
    }
    fileUrl(fn, cache = true, withMediaToken = true) {
        var url = new URL(this.rootPath() + '/' + fn);
        if (withMediaToken)
            url.searchParams.append("access_token", this.vasat.mediaToken);
        if (!cache)
            url.searchParams.append("__rand", Math.random().toString());
        return url.toString();
    }
    rootPath() {
        var p = this.urlPath();
        if (p.startsWith('http://') || p.startsWith('https://'))
            return p;
        else
            return this.vasat.config.host + this.urlPath();
    }
    domainName() {
        return this._domainName;
    }
    className() {
        return this._objType;
    }
    sendFile(f, name = f.name, chunkSize = 10000000) {
        var h = null;
        if (f.size < chunkSize) {
            h = new chunked_upload_1.SimpleUpload(this, name);
        }
        else {
            h = new chunked_upload_1.ChunkedFileUploader(this, name, chunkSize);
        }
        h.upload(f, name);
        return h;
    }
    deleteFile(name) {
        return this.vasat.api(this.urlPath() + '/' + name, 'delete');
    }
}
exports.VasatModel = VasatModel;
class VasatAccessModel extends VasatModel {
}
exports.VasatAccessModel = VasatAccessModel;
class VasatSearchQuery extends VasatAPICall {
    constructor(clazz, vasat, searchUrl) {
        super();
        this.clazz = clazz;
        this.vasat = vasat;
        this.searchUrl = searchUrl;
        this.queryParams = { limit: 100 };
        this._resSubject = new rxjs_1.Subject();
        this.items = this._resSubject.asObservable();
        this.resultCache = [];
        if (searchUrl && searchUrl.startsWith('/'))
            searchUrl = searchUrl.substring(1);
        if (searchUrl)
            this.searchUrl = '/' + searchUrl;
    }
    _castToString(v) {
        if (v == null) {
            return "null";
        }
        else if (v instanceof VasatModel) {
            return "" + v.id;
        }
        else if (v instanceof Date) {
            return "" + v.getTime();
        }
        else {
            return "" + v;
        }
    }
    isNull(column) {
        this.queryParams[column] = "null";
        return this;
    }
    isNotNull(column) {
        this.queryParams[column] = "!null";
        return this;
    }
    complexQuery(value) {
        this.queryParams['query'] = JSON.stringify(value);
        return this;
    }
    equals(column, value) {
        this.queryParams[column] = this._castToString(value);
        return this;
    }
    equalsAny(column, value) {
        let s = "";
        value.forEach(v => s += this._castToString(value) + "|");
        if (s.length)
            s = s.substring(0, s.length - 1);
        this.equals(column, s);
        return this;
    }
    contains(column, value) {
        this.queryParams[column] = "~" + this._castToString(value);
        return this;
    }
    greaterThan(column, value) {
        this.queryParams[column] = ">" + this._castToString(value);
        return this;
    }
    lessThan(column, value) {
        this.queryParams[column] = "<" + this._castToString(value);
        return this;
    }
    notEquals(column, value) {
        this.queryParams[column] = "!" + this._castToString(value);
        return this;
    }
    notContains(column, value) {
        this.queryParams[column] = "!~" + this._castToString(value);
        return this;
    }
    notGreaterThan(column, value) {
        this.queryParams[column] = "!>" + this._castToString(value);
        return this;
    }
    notLessThan(column, value) {
        this.queryParams[column] = "!<" + this._castToString(value);
        return this;
    }
    sortBy(column, descend) {
        this.queryParams['sortby'] = column;
        this.queryParams['sortbyorder'] = descend ? 'down' : 'up';
        return this;
    }
    limit(limit) {
        this.queryParams['limit'] = limit;
        return this;
    }
    offset(offset) {
        this.queryParams['offset'] = offset;
        return this;
    }
    addQueryParams(params) {
        this.queryParams = Object.assign(Object.assign({}, this.queryParams), params);
    }
    query() {
        return this._query(true);
    }
    /**
     * @deprecated renamed. use query instead
     */
    queryObservable() {
        return this._query(true);
    }
    queryObservableBYO(searchRes) {
        return this._query(true, searchRes);
    }
    remove(obj) {
        this.removeObservable(obj).subscribe();
    }
    removeObservable(obj) {
        return this.vasat.api(this.vasat.pathPrefix + this.searchUrl + '/' + obj.id, 'delete').pipe((0, operators_1.map)(r => {
            if (this.resultCache.find(a => a == obj)) {
                this.resultCache = this.resultCache.filter(a => a != obj);
                this._resSubject.next(this.resultCache);
            }
            return r;
        }));
    }
    useCache(cache) {
        this._useCache = cache;
        return this;
    }
    _query(ob, searchRes) {
        var fn = this.clazz;
        var bm = new fn(this.vasat);
        var serialize = function (obj) {
            var str = [];
            for (var p in obj)
                if (obj.hasOwnProperty(p)) {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
            return str.join("&");
        };
        var enc = serialize(this.queryParams);
        var hasQ = enc.length;
        let url = this.searchUrl ? this.searchUrl : bm.urlRoot();
        if (ob)
            return this.apiObservable(this.vasat, 'get', url + (hasQ ? ("?" + enc) : ''), null, { res: searchRes }).pipe((0, operators_1.map)(r => {
                this._resSubject.next(r.items);
                this.resultCache = r.items;
                return r;
            }));
        else
            return this.apiObservable(this.vasat, 'get', url + (hasQ ? ("?" + enc) : ''), null, { res: searchRes }).subscribe();
    }
    postProcess(meth, url, resp, postObj, args) {
        // cast items into the object type
        var items = resp.payload.results.map((cur) => {
            if (this._useCache) {
                let cached = this.vasat.findCached(this.clazz, cur.id);
                cached = (cached || new this.clazz(this.vasat, ''));
                return cached.set(cur);
            }
            else {
                return new this.clazz(this.vasat, '').set(cur);
            }
        });
        if (this._useCache) {
            this.vasat.registerCacheClass(this.clazz, items);
        }
        let scope = {};
        return (items.length ? (0, rxjs_1.forkJoin)(items.map(i => i.postSet(i, scope))) : (0, rxjs_1.of)(items)).pipe((0, operators_1.map)(_ => {
            // if there was a BYO search results update it
            if (args && args['res']) {
                var sr = args['res'];
                sr.items = items;
                sr.setFromResponse(resp, this.queryParams.limit);
                return sr;
            }
            else
                return new SearchResults(this.clazz, resp, this.queryParams, this, this.queryParams.limit, items, this.vasat);
        }));
    }
}
exports.VasatSearchQuery = VasatSearchQuery;
class SearchResults {
    constructor(clazz, resp, query, queryObj, limit, items, vasat) {
        this.clazz = clazz;
        this.resp = resp;
        this.query = query;
        this.queryObj = queryObj;
        this.items = items;
        this.vasat = vasat;
        this.setFromResponse(resp, limit);
        this.pageUpdate = new rxjs_1.Subject();
        this.pageUpdate
            .asObservable().pipe((0, operators_1.debounceTime)(300), (0, operators_1.distinctUntilChanged)())
            .subscribe((n) => this.currentPage = n);
    }
    setFromResponse(resp, limit) {
        this._currentPage = Math.floor(resp.payload.offset / limit);
        this.pages = Math.ceil(resp.payload.total / limit);
        this.total = resp.payload.total;
        this.offset = resp.payload.offset;
    }
    get limit() {
        return this.query['limit'];
    }
    get sortBy() {
        return this.query['sortby'];
    }
    get sortDown() {
        return this.query['sortbyorder'] == 'down';
    }
    get currentPageP1() {
        return this._currentPage + 1;
    }
    set currentPageP1(p) {
        this.pageUpdate.next(!p ? 0 : p - 1);
    }
    get currentPage() {
        return this._currentPage;
    }
    set sortBy(s) {
        if (s != this.sortBy) {
            this.queryObj
                .sortBy(s, this.sortDown)
                .queryObservableBYO(this).subscribe(r => {
            });
        }
    }
    set limit(s) {
        if (s != this.limit) {
            this.queryObj
                .limit(s)
                .queryObservableBYO(this).subscribe(r => {
            });
        }
    }
    set sortDown(s) {
        if (this.sortDown != s) {
            this.queryObj
                .sortBy(this.sortBy, s)
                .queryObservableBYO(this).subscribe(r => {
            });
        }
    }
    set currentPage(p) {
        if (p != this._currentPage) {
            this.queryObj
                .offset(p * this.limit)
                .queryObservableBYO(this).subscribe(r => {
            });
        }
        this._currentPage = p;
    }
    refresh() {
        this.queryObj
            .queryObservableBYO(this).subscribe(r => {
        });
    }
}
exports.SearchResults = SearchResults;
class ToManyList extends VasatSearchQuery {
    constructor(clazz, parent, name) {
        super(clazz, parent.vasat, parent.urlRoot());
        this.parent = parent;
        this.name = name;
    }
    _updateURL() {
        this.searchUrl = this.parent.urlRoot() + '/' + this.parent.id + '.' + this.name;
    }
    _query(ob, sr) {
        this._updateURL();
        return super._query(ob, sr);
    }
    /**
     * @deprecated Renamed to add()
     */
    addObserveable(obj) {
        return this.add(obj);
    }
    add(adds) {
        this._updateURL();
        var toPost = [];
        if (Array.isArray(adds))
            toPost = adds.map(a => a.id);
        else
            toPost = [adds.id];
        return this.vasat.api(this.searchUrl, 'post', toPost).pipe((0, operators_1.map)(r => {
            toPost.map(aa => this.resultCache
                .filter(rc => rc.id == aa)
                .filter(a => !!a)
                .forEach(a => {
                this.resultCache.push(a);
                this._resSubject.next(this.resultCache);
            }));
            return r;
        }));
    }
    /**
     *
     * @deprecated Use remove() instead
     */
    removeObservable(obj) {
        return this.remove(obj);
    }
    remove(removes) {
        var toPost = [];
        if (Array.isArray(removes))
            toPost = removes.map(a => a.id);
        else
            toPost = [removes.id];
        this._updateURL();
        return this.vasat.api(this.searchUrl, 'delete', toPost).pipe((0, operators_1.map)(r => {
            toPost.map(aa => this.resultCache
                .filter(rc => rc.id == aa)
                .filter(a => !!a)
                .forEach(a => {
                this.resultCache = this.resultCache.filter(aa => aa != a);
                this._resSubject.next(this.resultCache);
            }));
            return r;
        }));
    }
}
exports.ToManyList = ToManyList;
class FileRef extends VasatModel {
    urlPath() {
        return super.urlPath() + '.files';
    }
}
exports.FileRef = FileRef;
